
import React, {useEffect} from 'react';
import Turnstile, { useTurnstile } from "react-turnstile";

const CustomTurnstile = (props:any) => {
    const turnstile = useTurnstile()
    
    useEffect(() => {
        if(props.resetCaptcha){
            turnstile.reset()
        }
    },[props.resetCaptcha])
    
    return(
        <Turnstile 
            sitekey={props.sitekey} 
            onVerify={props.onVerify}
            onError={() => {
                turnstile.reset()
            }}
        />
        
    )
}

export default React.memo(CustomTurnstile)